export default __webpack_public_path__ + "static/media/tunnistautuminen-2.aece62a1.png";